module.exports = __webpack_public_path__ + "img/img11.6260e53d.jpg";